import React from 'react'

function Withdraw() {
  return (
    <div>Withdraw</div>
  )
}

export default Withdraw